export const eventSessionEnd = `<svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="7" y="7" width="17" height="17" rx="2" fill="currentColor"/>
</svg>`;
